import request from '@/utils/request'

/**
 * 打手公告管理
 */

// 获取打手公告列表
export const getGoonsAnnouncementList = () => {
  return request({
    url: '/admin/goons-announcement/list',
    method: 'get'
  })
}

// 新增打手公告
export const addGoonsAnnouncement = (params: any) => {
  return request({
    url: '/admin/goons-announcement',
    method: 'post',
    data: { ...params }
  })
}

// 修改打手公告
export const editGoonsAnnouncement = (params: any) => {
  return request({
    url: '/admin/goons-announcement',
    method: 'put',
    data: { ...params }
  })
}

// 删除打手公告
export const deleteGoonsAnnouncement = (id: string) => {
  return request({
    url: `/admin/goons-announcement/${id}`,
    method: 'delete'
  })
}

// 根据ID查询打手公告
export const queryGoonsAnnouncementById = (id: string | (string | null)[]) => {
  return request({
    url: `/admin/goons-announcement/${id}`,
    method: 'get'
  })
}

// 更新打手公告状态
export const updateGoonsAnnouncementStatus = (id: string, status: string) => {
  return request({
    url: `/admin/goons-announcement/status/${status}`,
    method: 'put',
    params: { id }
  })
}

